import { Navigate } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import { Loader2 } from 'lucide-react';

export default function AdminRoute({ children }) {
    const { user, loading } = useAuth();
    if (loading || user === undefined) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-[#F5F7FA]" data-testid="admin-loading">
                <Loader2 className="w-6 h-6 animate-spin text-slate-500" />
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    if (user.role !== 'admin') {
        return (
            <div className="min-h-screen flex items-center justify-center bg-[#F5F7FA] px-4" data-testid="admin-forbidden">
                <div className="surface-1 rounded-md p-8 max-w-md text-center">
                    <div className="overline text-[#FF453A]">Access Denied</div>
                    <h2 className="font-display text-2xl font-bold text-slate-900 mt-2">Admin only</h2>
                    <p className="text-sm text-slate-500 mt-2">You need admin privileges to view this page.</p>
                </div>
            </div>
        );
    }
    return children;
}
